import type { RuleEditorProps } from "./rule-editor-props"
import { ChainEditor } from "./chain-editor"
import { EnumEditor } from "./enum-editor"
import { FixedValueEditor } from "./fixed-value-editor"

/** The control for the mode the rule is in. */
export function RuleEditor({ rule, ...props }: RuleEditorProps) {
	if (rule.mode === "ref" || rule.mode === "template") {
		return <ChainEditor {...props} rule={rule} />
	}

	if (rule.mode === "fixed" || rule.mode === "json") {
		return <FixedValueEditor {...props} rule={rule} />
	}

	if (rule.mode === "enum") {
		return (
			<EnumEditor
				field={props.field}
				values={rule.values}
				onChange={(values) => props.onChange({ mode: "enum", values })}
			/>
		)
	}

	return null
}
